function isHTML<T extends string>(value: T) {
    if (typeof value !== "string") return false;

    const a = document.createElement("div");
    a.innerHTML = value;

    for (let c = a.childNodes, i = c.length; i--; ) {
        if (c[i].nodeType == 1) {
            return true;
        }
    }

    return false;
}

export function getTextFromHTML<T>(value: T) {
    if (typeof value !== "string") {
        return "";
    }

    if (!isHTML(value)) {
        return value;
    }

    const parsedText = new DOMParser().parseFromString(value, "text/html").documentElement.textContent;
    // Remove new lines and trim the text
    const withoutNewlines = (parsedText ?? "").replace(/\n+/g, " ").trim();
    // Remove duplicate words occurrences, for example: "504 Gateway Time-out 504 Gateway Time-out" will become "504 Gateway Time-out"
    return withoutNewlines.replace(/\b(\S.+?)\b(?=.*\b\1\b)/gi, "").trim();
}
